import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';
import { NAMESPACE } from './constants';
import { renderChatBubbles } from 'Container/Ui/helpers/renderWebchatBubbles';

import { createStructuredSelector } from 'reselect';
import refreshWebchatReducer from './reducer';
import refreshWebchatSaga from './sagas';
import {
    selectError,
    selectWebchatResponse,
    selectAgentTakeOver,
    selectWebChatEnded,
    selectWebchatNextPosition,
} from './selector';

import { RootState } from './types';
import { WEBCHAT_HAS_ENDED } from 'Constant';
import { renderWebchatResponse } from './helpers/renderWebchatResponse';
import { selectBotName } from 'Container/Ui/selector';

import {
    sendWebchatMessage,
} from '../SendMessage/actions';

import { handOverToAgent } from './actions';

import { messageFromAgentOrBotHasSent } from '../Ui/actions';

function refreshWebchat (_state, actions) {

    injectReducer(NAMESPACE, refreshWebchatReducer);
    injectSaga(NAMESPACE, refreshWebchatSaga);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState
         */
        getDerivedStateFromProps (newState, oldState) {

            if (newState.error && (newState.error !== oldState.error)) {
                // renderChatBubbles([WEBCHAT_TECHNICAL_ERROR], false);
                // TODO: what should happen??
                return;
            }

            if (newState.webchatEnded && (newState.webchatEnded !== oldState.webchatEnded)) {
                renderChatBubbles([WEBCHAT_HAS_ENDED], false);
            }

            // if there is no respone or response is empty do nothing
            if (!newState.response || 0 === newState.response.length) {
                return;
            }

            /**
             * render Message from webchat
             */
            if (newState.response !== oldState.response) {
                // handleResponse from webchat
                renderWebchatResponse(newState.response, newState.nextPosition, newState.botName, actions.sendWebchatMessage, actions.handOverToAgent, actions.messageFromAgentOrBotHasSent, newState.agent);
            }
        },
    };

}

/**
 * mapStateToProps = We are mapping the given states to props mapDispatch
 */
const mapStateToProps = createStructuredSelector<RootState, {}>({
    error: selectError(),
    response: selectWebchatResponse(),
    botName: selectBotName(),
    agent: selectAgentTakeOver(),
    webchatEnded: selectWebChatEnded(),
    nextPosition: selectWebchatNextPosition(),
});

/**
 * mapDispatch = We are mapping the given action dispatch function to props Result.
 * You can use the states and dispatches as a prop in the main function
 */
const mapDispatch = {
    sendWebchatMessage,
    handOverToAgent,
    messageFromAgentOrBotHasSent,
};

const RefreshWebchat = connect(mapStateToProps, mapDispatch)(refreshWebchat);

export default RefreshWebchat;
